// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__fGRrj","smallWrapper":"styles_smallWrapper__3Zziz"};